module.exports = __webpack_public_path__ + "static/media/33_A.6b983fc7.png";